export default () => {
  $(function () {
    // bind change event to select
    $('#invoice_period_select').on('change', function () {
      var url = $(this).val(); // get selected value
      if (url) {
        // require a URL
        window.location = url; // redirect
      }
      return false;
    });
  });

  // apocash deactivate tag manager WEB-5058
  const modalApocashDeactivationSumbit = $('#ds5_modal_deactivate').find('form');
  modalApocashDeactivationSumbit.on('submit', function () {
    window.dataLayer.push({
      event: 'apo_cash_deactivation',
      location: 'customer_account',
      customer_id: cusid,
    });
  });
};
